const ComponentsLookup = {
  "default-footer": "DefaultFooter1c9e7793519b4a2aA0e4A47cb1856e85"
}

export default ComponentsLookup;